import {skipToken} from '@reduxjs/toolkit/query';

import {isNil, isNotNil} from 'ramda';

import {useGetBusinessCaseQuery} from '@dms/api/sales';
import {TestDriveTooltipCard} from '@dms/features/test-drive';
import {businessCaseRoutes} from '@dms/routes';

import {
  composePath,
  EMPTY_PLACEHOLDER,
  RequiredTestIdProps,
  suffixTestId,
  useNavigate,
} from 'shared/web';

import {TestDriveSegment} from '../utils/getVehicleDriveSegments';

export type HoveredTestDrive = {
  segment: TestDriveSegment;
  vehicleTitle: string;
};

interface TestDriveEventTooltipProps extends RequiredTestIdProps {
  hovered: HoveredTestDrive | null;
}

export function TestDriveEventTooltip(props: TestDriveEventTooltipProps) {
  const navigate = useNavigate();

  const businessCaseId = props.hovered?.segment.drive.businessCaseId;
  const {currentData: businessCase} = useGetBusinessCaseQuery(
    isNotNil(businessCaseId) ? {businessCaseId} : skipToken
  );

  if (isNil(props.hovered)) {
    return null;
  }

  const {segment, vehicleTitle} = props.hovered;

  return (
    <TestDriveTooltipCard
      vehicleTitle={vehicleTitle}
      state={segment.drive.state}
      start={segment.actualStart}
      end={isNotNil(segment.drive.returnedAt) ? segment.actualEnd : null}
      customerName={segment.drive.customerDisplayName}
      phoneNumbers={segment.drive.customerPhoneNumbers}
      employeeName={segment.drive.userDisplayName ?? EMPTY_PLACEHOLDER}
      businessCaseCode={businessCase?.code}
      onBusinessCaseClick={
        isNotNil(businessCaseId)
          ? () => navigate(composePath(businessCaseRoutes.overview, {params: {id: businessCaseId}}))
          : undefined
      }
      note={segment.drive.note}
      data-testid={suffixTestId('tooltip', props)}
    />
  );
}
